<template>
  <div class="show-box">
    <img v-if="images[0]" class="img" :src="images[0]" @click="() => visible = !visible"/>
    <div style="display: none">
      <a-image-preview-group :preview="{ visible, onVisibleChange: vis => (visible = vis) }">
        <a-image v-for="(image, index) in images" :width="50" :src="image" :key="index"/>
      </a-image-preview-group>
    </div>
  </div>
</template>

<script setup lang="ts">
import {computed, defineProps, ref} from "vue";
import {ImgFieldType} from "@/components/business/crud/interface/FieldType";
import config from "@/config";
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer";

const props = defineProps<{
  propName: string;
  widget: ImgFieldType;
  info: WidgetInfo;
  data: any;
}>();

const images = computed(() => {
  const data = props.data[props.propName];
  if (data instanceof Array) {
    return data.filter(i => i).map(i => i.startsWith('/') ? config.uploadPath + i : i);
  }
  if (typeof data === 'string' && data) {
    return [data.startsWith('/') ? config.uploadPath + data : data];
  }
  return [];
})

const visible = ref(false);
</script>

<style lang="scss" scoped>
.show-box {
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;

  .img {
    width: 50px;
    height: 50px;
    object-fit: cover;
  }
}
</style>
